module.exports = __webpack_public_path__ + "img/no-image.6aec33a6.svg";